<template>
  <div class="dashboardAdmin-parentdiv bluebtn">
    <div
      class="
        dashboardAdmin-header
        d-flex
        justify-content-between
        align-items-center
        mt-4
      "
    >
      <div class="dashboardAdmin-header-main-head">
        <span>Hiring Process</span>
      </div>
      <div
        v-if="
          (roles.includes('PUSH_FEEDBACK_FORM') &&
            $route.query.status == 'feedbackForm') ||
          (roles.includes('PUSH_INTERVIEW') &&
            $route.query.status == 'interviewProcess')
        "
      >
        <b-button
          @click="openForm"
          class="
            new-blueBtn
            w-100
            d-flex
            align-items-center
            justify-content-center
          "
        >
          <img
            src="../../assets/New-imgs/teams-icons/plus-btn.svg"
            alt=""
            class="mr-2"
          />
          <span>{{ buttonText }}</span>
        </b-button>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <div
        class="
          newInt-main-container
          mt-3
          d-flex
          justify-content-between
          relativeclass
        "
        :style="
          (alldataLength != null && tabName === 'interviewProcess') ||
          (feedbackLength != null && tabName === 'feedbackForm')
            ? 'width: 70%;'
            : 'width:100%;'
        "
      >
        <div class="newInt-control-tabs w-100">
          <b-tabs content-class="mt-1 position-relative" v-model="tabIndex">
            <b-tab
              v-if="roles.includes('GET_INTERVIEW')"
              title="Interview Process"
              @click="
                (tabName = 'interviewProcess'), (viewIntProcess = {});
                tabsStatus(), resetValues(), (mainFilter = false);
              "
            >
              <div>
                <InterviewProcess
                  v-if="$route.query.status == 'interviewProcess'"
                  ref="interviewProcess"
                  @viewIntProcess="viewIntProcess = $event"
                  :interviewType="interviewType"
                  :sortColumn="sortColumn"
                  :sortOrder="sortOrder"
                  :sort_selected="sort_selected"
                  @update-alldata-length="updateAlldataLength"
                />
              </div>
            </b-tab>
            <b-tab
              v-if="roles.includes('GET_FEEDBACK_FORM')"
              title="Feedback Form"
              @click="
                (tabName = 'feedbackForm'),
                  tabsStatus(),
                  resetValues(),
                  (singleFeedbackForm = {}),
                  (mainFilter = false)
              "
            >
              <div>
                <Feedbackform
                  v-if="$route.query.status == 'feedbackForm'"
                  ref="feedbackForm"
                  @singleFeedbackForm="getSingleFeedbackForm"
                  :interviewType="interviewType"
                  :sortColumn="sortColumn"
                  :sortOrder="sortOrder"
                  :sort_selected="sort_selected"
                  @update-feedbackform-length="updateFeedbackLength"
                />
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <div
          v-closable="{
            exclude: ['recdropdown'],
            handler: 'hideinterviewoptions',
          }"
        >
          <b-button
            class="acs-addBtn btn-position"
            @click="
              (mainFilter = !mainFilter),
                (showtypecard = false),
                (showsortcard = false),
                (reset = false);
              interviewType = $route.query.type;
              sort_selected = $route.query.sort;
            "
            ><img
              class="mr-2"
              src="../../assets/img/accessconnew/whiteFilter.svg"
              alt=""
            />Filter</b-button
          >
          <div v-if="mainFilter" class="acs-filter p-3" style="width: 300px">
            <div>
              <div class="acs-black-txt">Type :</div>
              <div
                @click="(showtypecard = !showtypecard), (showsortcard = false)"
                class="acs-filter-dropdown mt-2 position-relative pointer"
              >
                <span
                  class="acs-filter-dropdown-place"
                  v-if="interviewType == ''"
                >
                  Select Type</span
                >
                <span class="acs-filter-dropdown-place" v-else>
                  {{ filterName }}</span
                >

                <img
                  src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                  alt=""
                />
              </div>
              <div v-if="showtypecard" class="relativeclass">
                <div class="newInt-radio-dropdown p-0">
                  <b-form-group class="sec-mcq-datacard">
                    <b-form-radio-group
                      class="newInt-radio-dropdown-inner-content w-100"
                      size="sm"
                      v-model="interviewType"
                      @change="closeType"
                      :options="interviewtypeoptions"
                      buttons
                      stacked
                    ></b-form-radio-group>
                  </b-form-group>
                </div>
              </div>
              <div class="mt-3">
                <div class="acs-black-txt">Sort By :</div>
                <div
                  @click="
                    (showsortcard = !showsortcard), (showtypecard = false)
                  "
                  class="acs-filter-dropdown mt-2 position-relative pointer"
                >
                  <span
                    class="acs-filter-dropdown-place"
                    v-if="sort_selected == ''"
                  >
                    Select</span
                  >
                  <span class="acs-filter-dropdown-place" v-else>
                    {{ sortName }}</span
                  >

                  <img
                    src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                    alt=""
                  />
                </div>

                <div v-if="showsortcard" class="relativeclass">
                  <div class="newInt-radio-dropdown p-0">
                    <b-form-group class="sec-mcq-datacard">
                      <b-form-radio-group
                        class="newInt-radio-dropdown-inner-content w-100"
                        size="sm"
                        v-model="sort_selected"
                        :options="sortoptions"
                        @change="saveSort"
                        buttons
                        stacked
                      ></b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-between mt-4 bluebtn">
                <b-button
                  class="acs-cancelBtn-filter"
                  @click="(mainFilter = false), (reset = false), resetValues()"
                  >Cancel</b-button
                >
                <div class="d-flex">
                  <b-button
                    class="acs-cancelBtn-filter mr-3"
                    @click="(reset = true), resetValues()"
                    >Reset</b-button
                  >
                  <b-button
                    class="acs-cancelBtn-filter"
                    @click="
                      $route.query.status == 'feedbackForm' &&
                      tabName === 'feedbackForm'
                        ? applyfeedbackFilter()
                        : applyFilter()
                    "
                    >Apply</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="hp-right-container ml-3 mt-3"
        v-if="
          (alldataLength != null && tabName === 'interviewProcess') ||
          (feedbackLength != null && tabName === 'feedbackForm')
        "
      >
        <!-- call this div when the view icon is not yet clicked -->
        <div
          class="
            d-flex
            flex-column
            align-items-center
            justify-content-center
            h-100
          "
          v-if="
            (Object.keys(singleFeedbackForm).length === 0 &&
              tabName === 'feedbackForm') ||
            (Object.keys(viewIntProcess).length == 0 &&
              tabName === 'interviewProcess')
          "
        >
          <img
            v-if="
              Object.keys(singleFeedbackForm).length === 0 &&
              tabName === 'feedbackForm'
            "
            src="../../assets/img/feedbackform/empty.svg"
            alt=""
          />
          <img
            v-else-if="
              Object.keys(viewIntProcess).length == 0 &&
              tabName === 'interviewProcess'
            "
            src="../../assets/intEmpty.svg"
            alt=""
          />

          <!-- use if we click on feed back form eye icon and if there is no data  -->
          <div
            class="pff-right-empty-txt"
            v-if="
              Object.keys(singleFeedbackForm).length === 0 &&
              tabName === 'feedbackForm'
            "
          >
            Click on the eye icon to view <br />
            feedback form details
          </div>

          <!-- use if we click on interview process eye icon and if there is no data  -->
          <div
            class="pff-right-empty-txt"
            v-else-if="
              Object.keys(viewIntProcess).length == 0 &&
              tabName === 'interviewProcess'
            "
          >
            Click on the eye icon to view <br />
            Interview Process details
          </div>
        </div>

        <!-- used in feedback form when the view icon is clicked  -->
        <div
          v-if="tabName === 'feedbackForm'"
          :class="
            Object.keys(singleFeedbackForm).length === 0 &&
            tabName === 'feedbackForm'
              ? ''
              : 'h-100 w-100'
          "
        >
          <div
            class="pff-right-header"
            v-if="Object.keys(singleFeedbackForm).length !== 0"
          >
            <div style="width: 98%" class="text-truncate">
              {{ singleFeedbackForm.name }}
            </div>
          </div>
          <div
            class="overflow-auto"
            :class="
              !singleFeedbackForm.active &&
              Object.keys(singleFeedbackForm).length !== 0
                ? 'newfdbk-activate-rightside-overflow'
                : singleFeedbackForm.active &&
                  Object.keys(singleFeedbackForm).length !== 0
                ? 'newInt-rightside-overflow'
                : ''
            "
          >
            <div class="px-3 pt-2 pb-0 h-100">
              <div
                class="pt-2 pb-0"
                v-for="(input, index) in singleFeedbackForm.skills"
                :key="index"
              >
                <div class="pff-right-content-cards">
                  <div class="pff-right-card-main-txt wordbreak">
                    {{ input.name }}&nbsp;<span
                      v-if="input.mandatory == true"
                      class="asterik"
                      >*</span
                    >
                  </div>
                  <div v-if="input.markingType == 'rating'" class="pff-rating">
                    <div class="hiringprocess-rating d-flex align-items-center">
                      <div class="pff-add-card-headings">Rating</div>
                      <b-form-rating
                        v-model="input.mark"
                        variant="primary"
                        class="scorerate w-25 newInt-rating"
                        disabled
                      ></b-form-rating>
                    </div>
                  </div>
                  <div
                    v-if="input.markingType == 'score'"
                    class="d-flex align-items-center mt-2 mb-1"
                  >
                    <div class="pff-add-card-headings">Score</div>
                    <div class="topDiv ml-1 w-30px h23px">
                      <b-form-input
                        class="br-8px modaldisableinputField w-100 h-100"
                        id="input-1"
                        type="text"
                        disabled
                      >
                      </b-form-input>
                    </div>
                    <div class="pff-add-card-headings ml-1">out of 10</div>
                  </div>
                  <div v-if="input.commentMode == true" class="mt-2">
                    <div class="pff-add-card-headings">Comments</div>
                    <div class="topDiv mt-1">
                      <b-form-textarea
                        v-model="input.comments"
                        class="br-8px modaldisableinputField"
                        rows="2"
                        type="text"
                        placeholder="Comments will be shown here"
                        max-rows="5"
                        disabled
                      >
                      </b-form-textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="pff-right-content-cards"
                v-if="singleFeedbackForm.screenshot"
              >
                <div class="pff-right-card-main-txt">
                  Candidate Screenshot<span class="asterik">*</span>
                </div>
                <div class="d-flex justify-content-center w-100">
                  <div
                    class="
                      mt-3
                      feedback-ss-container
                      d-flex
                      align-items-center
                      justify-content-center
                      w-100
                    "
                  >
                    <div>Screenshot will be shown here</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr
            v-if="
              !singleFeedbackForm.active &&
              Object.keys(singleFeedbackForm).length !== 0
            "
          />

          <div
            v-if="
              !singleFeedbackForm.active &&
              Object.keys(singleFeedbackForm).length !== 0
            "
            class="w-100 d-flex align-items-center justify-content-end pr-2"
          >
            <b-button @click="gotoActivatefeedback()" class="new-blueBtn">
              <img
                src="../../assets/New-imgs/interviewProcess-icons/newInt-activateBtn.svg"
                alt=""
                class="mr-2 mb-1"
              />
              <span> Activate </span>
            </b-button>
          </div>
        </div>

        <!-- used in interview process when the view icon is clicked  -->

        <div
          class="newInt-rs-container"
          v-if="
            Object.keys(viewIntProcess).length != 0 &&
            tabName === 'interviewProcess'
          "
        >
          <div class="newInt-rs-mainhead mt-3 ml-2">Interview Process</div>
          <hr class="mb-2" />
          <div class="h-100">
            <div
              class="p-2"
              :class="
                viewIntProcess.active
                  ? 'newInt-rightside-overflow'
                  : 'newInt-activate-rightside-overflow'
              "
            >
              <div>
                <div class="newInt-rs-head">Interview Process Name</div>
                <div class="newInt-rs-subhead wordbreak mt-1">
                  {{ viewIntProcess.name }}
                </div>
              </div>

              <div class="mt-3">
                <div class="newInt-rs-head">No.of Rounds</div>
                <div class="newInt-rs-subhead mt-1">
                  {{ viewIntProcess.process.length - 5 }}
                </div>
              </div>

              <div class="mt-3">
                <div class="newInt-rs-head">Count of Tagged Jobs</div>
                <div class="newInt-rs-subhead mt-1">
                  {{ viewIntProcess.jdcount }}
                </div>
              </div>
              <hr />

              <div class="newInt-rs-intProcess-container">
                <div class="newInt-rs-intProcess-container-mainhead">
                  Interview Rounds
                </div>
                <div
                  v-for="(i, index) in viewIntProcess.process.slice(1, -4)"
                  :key="index"
                  class="d-flex align-items-center justify-content-between"
                >
                  <div class="d-flex">
                    <!-- use this class if it is the last index final-lock-box -->
                    <div
                      :class="
                        index == viewIntProcess.process.length - 6
                          ? 'newInt-final-lock-box'
                          : 'newInt-lock-box'
                      "
                    >
                      <img
                        src="../../assets/New-imgs/interviewProcess-icons/newInt-round-circle.svg"
                        alt=""
                      />
                    </div>

                    <div class="mt-4">
                      <div
                        class="newInt-rs-intProcess-container-head"
                        v-if="i.type == 'assesment'"
                      >
                        Assesment
                      </div>
                      <div
                        class="newInt-rs-intProcess-container-head"
                        v-else-if="i.type == 'f2f'"
                      >
                        Face to Face
                      </div>
                      <div
                        class="
                          newInt-rs-intProcess-container-subhead
                          wordbreak
                          mt-1
                        "
                      >
                        {{ i.name }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <img
                      v-if="
                        i.type == 'assesment' &&
                        index != viewIntProcess.process.length - 5
                      "
                      src="../../assets/New-imgs/interviewProcess-icons/newInt-rs-assess.svg"
                      alt=""
                    />

                    <img
                      v-else-if="
                        i.type == 'f2f' &&
                        index != viewIntProcess.process.length - 5
                      "
                      src="../../assets/New-imgs/interviewProcess-icons/newInt-rs-f2f.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr v-if="!viewIntProcess.active" />

            <div
              v-if="!viewIntProcess.active"
              class="w-100 d-flex align-items-center justify-content-end pr-2"
            >
              <b-button @click="gotoActivate()" class="new-blueBtn">
                <img
                  src="../../assets/New-imgs/interviewProcess-icons/newInt-activateBtn.svg"
                  alt=""
                  class="mr-2 mb-1"
                />
                <span> Activate </span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CreateForm
      v-if="isCreateForm"
      :isCreateForm="isCreateForm"
      :createForm="createForm"
      @closeModal="closeModal"
      :showButtonLoader="showButtonLoader"
      @handle-create-form="goToCreateForm"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InterviewProcess from "../InterviewProcess/InterviewProcessDashboard.vue";
import Feedbackform from "../InterviewProcess/PreviewFeedbackForm.vue";
import { addintprocess, addfeedbackform } from "../../utils/apiFunctions.js";
import toast from "../../components/mixin/toast";
import CreateForm from "../InterviewProcess/CreateForm.vue";
export default {
  name: "HiringProcess",
  mixins: [toast],
  data() {
    return {
      isCreateForm: false,
      alldataLength: null,
      showButtonLoader: false,
      feedbackLength: null,
      createForm: {
        name: "",
        countOf: null,
        header: "",
        subHeader: "",
        placeholder: "Enter",
        count: "",
        errorMessage: "",
      },

      reset: false,
      tabName: "interviewProcess",
      tabIndex: 0,
      interviewType: "1",
      sortOrder: "-1",

      sortColumn: "updatedAt",
      loopVar: 4,
      mainFilter: false,
      viewIntProcess: {},
      sort_selected: "6",

      sortoptions: [
        { text: "Name(Asce)", value: "1" },
        { text: "Name(Desc)", value: "2" },
        { text: "Date Created(Asce)", value: "3" },
        { text: "Date Created(Desc)", value: "4" },
        { text: "Date Modified(Asce)", value: "5" },
        { text: "Date Modified(Desc)(Default)", value: "6" },
      ],
      interviewtypeoptions: [
        { text: "All", value: "2" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" },
      ],
      showtypecard: false,
      showsortcard: false,
      singleFeedbackForm: {},
    };
  },
  components: {
    InterviewProcess,
    Feedbackform,
    CreateForm,
  },
  watch: {
    $route() {
      if (this.$route.query.status == "interviewProcess") {
        this.tabName = "interviewProcess";
        this.tabIndex = 0;
      } else {
        this.tabName = "feedbackForm";
        this.tabIndex = 1;
      }
      this.tabRedirect();
    },
    tabName(newValue) {
      if (
        newValue == "interviewProcess" &&
        this.$route.query?.key != "fromJD"
      ) {
        this.$router.push({
          name: `HiringProcessDashboard`,
          query: {
            status: "interviewProcess",
            type: this.interviewType,
            sort: this.sort_selected,
          },
        });

        this.saveSort();
      } else if (
        newValue == "feedbackForm" &&
        this.$route.query?.key != "fromJD"
      ) {
        this.$router.push({
          name: "HiringProcessDashboard",
          query: {
            status: "feedbackForm",
            type: this.interviewType,
            sort: this.sort_selected,
          },
        });

        this.saveSort();
      }
    },
  },
  computed: {
    buttonText() {
      if (
        this.roles.includes("PUSH_INTERVIEW") &&
        this.$route.query.status === "interviewProcess"
      ) {
        return "Interview Process";
      } else if (
        this.roles.includes("PUSH_FEEDBACK_FORM") &&
        this.$route.query.status === "feedbackForm"
      ) {
        return "Feedback Form";
      }
      return "";
    },
    ...mapGetters(["roles"]),
    filterName() {
      if (this.interviewType == "0") {
        return "Inactive";
      } else if (this.interviewType == "1") {
        return "Active";
      } else if (this.interviewType == "2") {
        return "All";
      }
      return "Active";
    },

    sortName() {
      if (this.sort_selected == "1") {
        return "Name(Asce)";
      } else if (this.sort_selected == "2") {
        return "Name(Desc)";
      } else if (this.sort_selected == "3") {
        return "Date Created(Asce)";
      } else if (this.sort_selected == "4") {
        return "Date Created(Desc)";
      } else if (this.sort_selected == "5") {
        return "Date Modified(Asce)";
      }
      return "Date Modified(Desc)";
    },
    ...mapGetters(["roles"]),
  },

  created() {
    const setTabAndStatus = (status, tabIndex) => {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          status: status,
        },
      });
      this.tabName = status;
      this.tabIndex = tabIndex;
    };

    if (this.$route.query.status === "interviewProcess") {
      this.tabName = "interviewProcess";
      this.tabIndex = 0;
    } else if (this.$route.query.status === "feedbackForm") {
      this.tabName = "feedbackForm";
      this.tabIndex = 1;
    }

    const hasInterviewRole = this.roles.includes("GET_INTERVIEW");
    const hasFeedbackRole = this.roles.includes("GET_FEEDBACK_FORM");

    if (hasInterviewRole && !hasFeedbackRole) {
      setTabAndStatus("interviewProcess", 0);
    } else if (hasFeedbackRole && !hasInterviewRole) {
      setTabAndStatus("feedbackForm");
    }
    this.tabRedirect();
    this.openModal();
  },

  methods: {
    openModal() {
      const key = this.$route.query.key;
      if (key === "fromJD") {
        this.openForm();
      }
    },
    openForm() {
      const status = this.$route.query.status;

      this.createForm.header =
        status === "interviewProcess"
          ? "Create Interview Process"
          : "Create Feedback Form";

      this.createForm.subHeader =
        status === "interviewProcess"
          ? "Interview Process Name"
          : "Feedback Form Name";

      this.createForm.count =
        status === "interviewProcess" ? "No of rounds" : "No of skills";

      this.isCreateForm = true;
      this.createForm.name = "";
      this.createForm.countOf = null;
    },
    async goToCreateForm() {
      this.showButtonLoader = true;
      const { status } = this.$route.query;
      const commonQueryParams = {
        type: this.interviewType,
        sort: this.sort_selected,
      };

      try {
        if (status === "interviewProcess") {
          this.$store.commit("scheduleInterviewVUEX/saveInterviewProcess", {});
          let payload = {
            name: this.createForm.name,
            numberOfRounds: this.createForm.countOf,
          };

          const res = await addintprocess(payload);
          if (res.status === 409) {
            this.showButtonLoader = false;
            return this.errorModal(res.data.data.Detail);
          }

          this.$router.push({
            name: "CreateInterviewProcess",
            params: { status_i: status },
            query: {
              ...this.$route.query,
              ...commonQueryParams,
              status: "interviewProcess",
              name: this.createForm.name,
              count: this.createForm.countOf,
            },
          });
          this.showButtonLoader = false;
        } else if (status === "feedbackForm") {
          let payload = {
            name: this.createForm.name,
            skills: [],
          };

          const res = await addfeedbackform(payload);
          if (res.status === 409) {
            this.showButtonLoader = false;
            return this.errorModal(res.data.data.Detail);
          }

          this.$router.push({
            name: "Feedbackform",
            params: { status_i: status },
            query: {
              ...this.$route.query,
              ...commonQueryParams,
              status: "previewFeedbackForm",
              name: this.createForm.name,
              count: this.createForm.countOf,
            },
          });
          this.showButtonLoader = false;
        }
      } catch (error) {
        console.error("Request failed:", error);
        this.errorModal("An unexpected error occurred.");
      }
    },

    closeModal() {
      if (this.$route.query.key == "fromJD") {
        this.goToJd();
        this.isCreateForm = false;
      } else {
        this.isCreateForm = false;
      }
      this.createForm.name = "";
      this.createForm.countOf = null;
    },
    goToJd(processID) {
      const { wtype, wsort, itype, isort, pageType, customerName } =
        this.$route.query;
      this.$router.push({
        name: this.$route.query.redirectTo,
        query: {
          to: "interview",
          type: pageType,
          wsort,
          wtype,
          itype,
          isort,
          customerName,
          ...(processID ? { process: processID } : {}),
          ...(this.$route.query.jobID
            ? { jobID: this.$route.query.jobID }
            : {}),
        },
      });
    },
    updateAlldataLength(len) {
      this.alldataLength = len;
    },
    updateFeedbackLength(len) {
      this.feedbackLength = len;
    },
    gotoActivatefeedback() {
      this.$router.push({
        name: "ActivateFeedbackForm",
        params: {
          feedbackFormID: this.singleFeedbackForm.feedbackFormID,
          type: this.$route.query.type,
        },
        query: {
          status: this.$route.query.status,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
        },
      });
    },
    gotoActivate() {
      this.$router.push({
        name: "ActivateInterview",
        params: {
          interviewProcessID: this.viewIntProcess.interviewProcessID,
        },
        query: {
          status: this.$route.query.status,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
        },
      });
    },
    tabsStatus() {
      if (this.tabName == "interviewProcess") {
        this.$router.push({
          query: {
            status: "interviewProcess",
          },
        });
      } else if (this.tabName == "feedbackForm") {
        this.$router.push({
          query: {
            status: "feedbackForm",
          },
        });
      }
    },

    closeType() {
      this.showtypecard = false;
    },
    tabRedirect() {
      if (this.$route.query.type || this.$route.query.sort) {
        this.interviewType = this.$route.query.type;
        this.sort_selected = this.$route.query.sort;
      }
    },
    saveSort() {
      this.LoaderStatus = true;
      this.showsortcard = false;
      switch (this.sort_selected) {
        case "1":
          this.sortColumn = "name";
          this.sortOrder = "1";
          break;
        case "2":
          this.sortColumn = "name";
          this.sortOrder = "-1";
          break;
        case "3":
          this.sortColumn = "createdAt";
          this.sortOrder = "1";
          break;
        case "4":
          this.sortColumn = "createdAt";
          this.sortOrder = "-1";
          break;
        case "5":
          this.sortColumn = "updatedAt";
          this.sortOrder = "1";
          break;
        default:
          this.sortColumn = "updatedAt";
          this.sortOrder = "-1";
      }
    },
    resetValues() {
      this.showtypecard = false;
      this.interviewType = "1";
      this.sort_selected = "6";
      this.sortColumn = "updatedAt";
      if (this.reset == true && this.tabName == "interviewProcess") {
        this.applyFilter();
      } else if (this.reset == true && this.tabName == "feedbackForm") {
        this.applyfeedbackFilter();
      }
    },
    applyFilter() {
      this.$router.push({
        name: "HiringProcessDashboard",
        query: {
          type: this.interviewType,
          sort: this.sort_selected,
          status: "interviewProcess",
        },
      });

      this.$refs.interviewProcess.resetPagination();
      this.loader = true;
      this.mainFilter = false;
      this.viewIntProcess = {};
    },
    applyfeedbackFilter() {
      this.$router.push({
        name: "HiringProcessDashboard",
        query: {
          type: this.interviewType,
          sort: this.sort_selected,
          status: "feedbackForm",
        },
      });
      this.$refs.feedbackForm.resetPagination();
      this.loader = true;
      this.mainFilter = false;
      this.singleFeedbackForm = {};
    },
    hideinterviewoptions() {
      this.mainFilter = false;
    },
    goToInterviewProcessForm() {
      this.$store.commit("scheduleInterviewVUEX/saveInterviewProcess", {});
      this.$router.push({
        name: "CreateInterviewProcess",
        params: {
          status_i: this.$route.query.status,
        },
        query: {
          type: this.interviewType,
          sort: this.sort_selected,
          status: "createInterviewProcess",
        },
      });
    },
    getSingleFeedbackForm(feedbackForm) {
      this.singleFeedbackForm = feedbackForm;
    },
  },
};
</script>

<style>
.hp-right-container {
  background: #ffffff;
  box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  height: calc(100vh - 174px);
  width: 30%;
}

.newInt-lock-box {
  width: 45px;
  height: 70px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.newInt-lock-box::before {
  content: "";
  height: 70px;
  width: 5px;
  background: #e1e4e5;
  position: absolute;
  top: 39px;
}

.newInt-final-lock-box {
  width: 45px;
  height: 70px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
</style>
